import { FC, useEffect, useState } from "react";
import Suspense from "../suspense/Suspense";
import { connect, ConnectedProps } from "react-redux";
import { favoriteActionCreators } from "../../actions/favoriteActions";
import { ApplicationState, AppThunkDispatch } from "../../store";
import FavoriteList from "./FavoriteList";
import { FavoriteEntry } from "../../store/favorite";
import DeleteFavoriteEntryModal from "./DeleteFavoriteEntryModal";

interface FavoriteProps extends ConnectedProps<typeof connector> {
}

const Favorite: FC<FavoriteProps> = (props) => {
    const [favoriteEntryToDelete, setFavoriteEntryToDelete] = useState<FavoriteEntry | null>(null);
    
    const { favoriteState } = props;
    const { readFavoriteData } = props;

    useEffect(() => {
        if ((favoriteState.data === undefined || favoriteState.error) && !favoriteState.isLoading) {
            readFavoriteData();
        }
    }, []);
    
    const handleFavoriteListDelete = (favoriteEntry: FavoriteEntry) => {
        setFavoriteEntryToDelete(favoriteEntry);
    }
    
    const handleModalClose = () => {
        setFavoriteEntryToDelete(null);
    }
    
    const isDeleteModalVisible = favoriteEntryToDelete !== null;

    return (
        <>
            <DeleteFavoriteEntryModal isVisible={isDeleteModalVisible} favoriteEntry={favoriteEntryToDelete!} onClose={handleModalClose} />
        
            <div className="favorite-list-container">             
                <div className="favorites-list col">
                    <h2>Favorites</h2>
                    <Suspense isLoading={favoriteState.isLoading && !isDeleteModalVisible} error={favoriteState.error} errorDisplayMessage={"There was a problem reading Favorites. Please try again later"} data={favoriteState.data}>
                        {(favoriteData) => (
                            <FavoriteList favoriteEntries={favoriteData.favs} onDelete={handleFavoriteListDelete} />
                        )}
                    </Suspense>
                </div>
                
            </div>
        </>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const favoriteState = state.favorite;

    return { favoriteState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    readFavoriteData: () => {
        dispatch(favoriteActionCreators.readFavoriteData());
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(Favorite);